import { actionType } from './actions';

const initialState = {
    editFiling: {},
    filingInfoData: {},
    newFiling: {},
    filingRequestData: {
        filingPriorityType: '',
        amount: '',
        isCommission: '',
        isInitialPurchase: '',
        isInstitutionalExemption: '',
        requestTransactionType: '',
        requestAccountType: ''
    },
    searchByEffectiveDateResult: [],
    searchReadyForRenewalResult: [],
    filingsByClientsList: [],
    terminatedFilingsList: [],
    everActiveFilingsList: [],
    searchByFileByDateResult: [],
    pendingFilings: [],
    cancelledFilings: [],
    recentExemptedFilings: [],
    pendingAmendments: [],
    clientData: {},
    stateData: {},
    selectedItemData: {},
    selectedState: {},
    selectedSecurity: {
        typeId: '',
        typeName: '', //One of trustId, portfolioId, classId, prospectusId
        id: ''
    },
    selectedFilings: [],
    selectedStates: [],
    states: [],
    isGridItemSelected: false,
    activeTabKey: 1,
    allActiveClientId: '',
    readyForRenewalClientId: '',
    terminatedFilingsClientId: '',
    everActiveFilingsClientId: '',
    fetching: false,
    fetched: false,
    error: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.REQUESTED_FILING_DATA: {
            return {
                ...state,
                fetching: true,
                fetched: false,
                error: false
            };
        }

        case actionType.SUBMIT_NEW_FILING_REQUEST:
        case actionType.SUBMIT_NEW_FILING_LIST_REQUEST:
        case actionType.APPROVE_FILING:
        case actionType.DENY_FILING:
        case actionType.IN_PROGRESS_FILING:
        case actionType.IN_PROGRESS_FILING_LIST:
        case actionType.SET_TO_BILLED_FILING:
        case actionType.SET_TO_BILLED_FILING_LIST:
        case actionType.SET_TO_PAID_FILING:
        case actionType.SET_TO_PAID_FILING_LIST:
        case actionType.SET_TO_HOLD_FOR_PAYMENT_FILING:
        case actionType.SET_TO_READY_FOR_RENEWAL_FILING:
        case actionType.TERMINATE_FILING:
        case actionType.HOLD_FILING:
        case actionType.CANCEL_FILING:
        case actionType.CHANGE_STATUS_FILING:
        case actionType.CHANGE_STATUS_FILING_LIST:
        case actionType.UPDATE_FILING:
        case actionType.SET_PENDING_FILING: {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.REJECTED_FILING_DATA: {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: true
            };
        }

        case actionType.FETCH_TRUST_STATES:
        case actionType.FETCH_PORTFOLIO_STATES:
        case actionType.FETCH_CLASS_STATES:
        case actionType.FETCH_PROSPECTUS_STATES: {
            return {
                ...state,
                states: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_PENDING_FILINGS: {
            return {
                ...state,
                pendingFilings: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_FILING_BY_ID: {
            return {
                ...state,
                editFiling: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_CANCELLED_FILINGS: {
            return {
                ...state,
                cancelledFilings: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_RECENT_EXEMPTED_FILINGS: {
            return {
                ...state,
                recentExemptedFilings: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_PENDING_AMENDMENTS: {
            return {
                ...state,
                pendingAmendments: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_FILINGS_BY_EFFECTIVEDATE: {
            return {
                ...state,
                searchByEffectiveDateResult: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_FILINGS_READY_FOR_RENEWAL: {
            return {
                ...state,
                searchReadyForRenewalResult: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_TERMINATED_FILINGS: {
            return {
                ...state,
                terminatedFilingsList: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_EVER_ACTIVE_FILINGS: {
            return {
                ...state,
                everActiveFilingsList: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_FILINGS_BY_CLIENT: {
            return {
                ...state,
                filingsByClientsList: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.CLEAR_EFFDATE_SEARCH: {
            return {
                ...state,
                searchByEffectiveDateResult: []
            };
        }

        case actionType.CLEAR_READY_FOR_RENEVAL_SEARCH: {
            return {
                ...state,
                searchReadyForRenewalResult: [],
                readyForRenewalClientId: ''
            };
        }

        case actionType.CLEAR_BYCLIENT_SEARCH: {
            return {
                ...state,
                filingsByClientsList: [],
                allActiveClientId: ''
            };
        }

        case actionType.CLEAR_TERMINATED_SEARCH: {
            return {
                ...state,
                terminatedFilingsList: [],
                terminatedFilingsClientId: ''
            };
        }

        case actionType.CLEAR_EVER_ACTIVE_SEARCH: {
            return {
                ...state,
                everActiveFilingsList: [],
                terminatedFilingsClientId: ''
            };
        }

        case actionType.FETCH_FILINGS_BY_FILEBY_DATE: {
            return {
                ...state,
                searchByFileByDateResult: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_CLIENT_DATA: {
            return {
                ...state,
                clientData: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_STATE_DATA: {
            return {
                ...state,
                stateData: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FILE_WITH_STATE: {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.CLEAR_FILINGS_DATA: {
            return {
                ...state,
                ...initialState
            };
        }

        case actionType.UPDATE_SECURITY_SELECTED: {
            return {
                ...state,
                selectedSecurity: action.payload
            };
        }

        case actionType.UPDATE_STATE_SELECTED: {
            return {
                ...state,
                selectedState: action.payload
            };
        }

        case actionType.UPDATE_FILING_SELECTED: {
            return {
                ...state,
                selectedItemData: action.payload
            };
        }

        case actionType.UPDATE_SELECTED_FILING_LIST: {
            return {
                ...state,
                selectedFilings: action.payload
            };
        }

        case actionType.UPDATE_NEW_FILING_PAYLOAD: {
            return {
                ...state,
                newFiling: action.payload
            };
        }

        case actionType.UPDATE_FILING_REQUEST_PAYLOAD: {
            return {
                ...state,
                filingRequestData: action.payload
            };
        }

        case actionType.UPDATE_EDIT_FILING_PAYLOAD: {
            return {
                ...state,
                editFiling: action.payload
            };
        }

        case actionType.UPDATE_FILING_INFO_DATA: {
            return {
                ...state,
                filingInfoData: action.payload
            };
        }

        case actionType.UPDATE_SELECTED_STATES_LIST: {
            return {
                ...state,
                selectedStates: action.payload
            };
        }

        case actionType.UPDATE_FILINGS_ACTIVE_TAB: {
            return {
                ...state,
                activeTabKey: action.payload
            };
        }

        case actionType.UPDATE_SEARCH_CLIENT_SELECTED: {
            return {
                ...state,
                [Object.keys(action.payload)[0]]:
                    action.payload[Object.keys(action.payload)[0]]
            };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/services/redux/employee/filing/reducers.js